import AuthService from '@/services/auth.service'
import { clearClientSession, CLIENT_ACCESS_DENIED_MESSAGE, isClientUser } from '@/utils/clientAccess'

export default {
  namespaced: true,
  state: {
    status: { 
      loggedIn: !!localStorage.getItem('auth_token') 
    },
    token: localStorage.getItem('auth_token') || '',
    user: JSON.parse(localStorage.getItem('user')) || null,
  },
  mutations: {
    LOGIN_SUCCESS(state, { token, user }) {
      state.status.loggedIn = true
      state.token = token
      state.user = user
    },
    LOGOUT(state) {
      state.status.loggedIn = false;
      state.token = '';
      state.user = null;
    },
    UPDATE_USER_DATA(state, userData) {
      state.user = { ...state.user, ...userData };      
      localStorage.setItem('user', JSON.stringify(state.user));
    }
  },
  actions: {
    async register({ commit }, userData) {
      const response = await AuthService.register(userData);

      if (!response?.token || !response?.user) {
        throw new Error('El servidor no devolvió una sesión válida.');
      }

      if (!isClientUser(response.user)) {
        clearClientSession();
        throw new Error(CLIENT_ACCESS_DENIED_MESSAGE);
      }

      localStorage.setItem('auth_token', response.token);
      localStorage.setItem('user', JSON.stringify(response.user));

      commit('LOGIN_SUCCESS', {
        token: response.token,
        user: response.user
      });

      AuthService.startInactivityTracking({ forceReset: true });

      return response;
    },
    async login({ commit }, userData) {
      const response = await AuthService.login(userData)

      if (!response?.token) {
        throw new Error('No se recibió un token válido')
      }

      if (!isClientUser(response.user)) {
        clearClientSession();
        const accessError = new Error(CLIENT_ACCESS_DENIED_MESSAGE);
        accessError.code = 'CLIENT_ROLE_REQUIRED';
        throw accessError;
      }

      localStorage.setItem('auth_token', response.token)
      if (response.user) {
        localStorage.setItem('user', JSON.stringify(response.user))
      }

      commit('LOGIN_SUCCESS', {
        token: response.token,
        user: response.user
      });

      AuthService.startInactivityTracking({ forceReset: true });

      return response
    },
    async logout({ commit }) {
      try {
        if (AuthService.logout) {
          await AuthService.logout();
        }
      } catch (error) {
        console.error('Error durante el logout en el servidor:', error);
      } finally {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user');
        // Limpiar sessionStorage para que el anuncio del pote se muestre en el próximo login
        sessionStorage.removeItem('pot_announcement_seen');
        commit('LOGOUT');
      }
    },
    updateUserData({ commit }, userData) {
      commit('UPDATE_USER_DATA', userData);
    }
    // Otras acciones...
  },
  getters: {
    isAuthenticated: state => {
      return state.status.loggedIn
    },
    currentUser: state => state.user,
    userName: state => {
      if (!state.user) return '';
      return state.user.name || state.user.email.split('@')[0];
    }
  }
}
